(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["map-partners"] && !Shopify.designMode) return;
  try {
    /**
   * Carte des points de vente, chargée à la demande.
   *
   * Mapbox GL pèse près de 1,5 Mo : il n'est téléchargé qu'au clic, une seule
   * fois par page. Les coordonnées voyagent dans un bloc JSON plutôt que dans
   * des attributs, ce qui évite toute question d'échappement.
   */
  class PartnersMap extends HTMLElement {
    connectedCallback() {
      this.button = this.querySelector('[data-map-activate]');
      if (!this.button) return;
      this.onActivate = this.activate.bind(this);
      this.button.addEventListener('click', this.onActivate);
    }

    disconnectedCallback() {
      if (this.button && this.onActivate) this.button.removeEventListener('click', this.onActivate);
      if (this.map) this.map.remove();
    }

    static loadLibrary(version) {
      if (PartnersMap.libraryPromise) return PartnersMap.libraryPromise;

      PartnersMap.libraryPromise = new Promise(function (resolve, reject) {
        var base = 'https://api.mapbox.com/mapbox-gl-js/' + version + '/mapbox-gl';

        var css = document.createElement('link');
        css.rel = 'stylesheet';
        css.href = base + '.css';
        document.head.appendChild(css);

        var script = document.createElement('script');
        script.src = base + '.js';
        script.onload = resolve;
        script.onerror = reject;
        document.head.appendChild(script);
      });

      return PartnersMap.libraryPromise;
    }

    points() {
      var holder = this.querySelector('[data-points]');
      if (!holder) return [];
      try {
        return JSON.parse(holder.textContent).filter(function (p) {
          return p.lat && p.lon;
        });
      } catch (error) {
        return [];
      }
    }

    async activate() {
      if (this.map) return;
      var points = this.points();
      if (!points.length) return;

      this.button.disabled = true;

      try {
        await PartnersMap.loadLibrary(this.dataset.glVersion);
      } catch (error) {
        // L'image statique reste affichée, la liste au-dessus reste utilisable.
        this.button.disabled = false;
        return;
      }

      window.mapboxgl.accessToken = this.dataset.token;

      this.map = new window.mapboxgl.Map({
        container: this.querySelector('[data-map-canvas]'),
        style: this.dataset.style,
        // Le cadrage est recalculé juste après sur l'ensemble des points.
        center: [Number(points[0].lon), Number(points[0].lat)],
        zoom: 8,
        cooperativeGestures: true,
      });

      this.map.addControl(new window.mapboxgl.NavigationControl({ showCompass: false }), 'top-right');

      var bounds = new window.mapboxgl.LngLatBounds();

      points.forEach((point) => {
        var coords = [Number(point.lon), Number(point.lat)];
        bounds.extend(coords);

        var content = document.createElement('div');
        var name = document.createElement('span');
        name.className = 'pmap__popup-name';
        name.textContent = point.name || '';
        content.appendChild(name);

        if (point.address) {
          var address = document.createElement('span');
          address.className = 'pmap__popup-address';
          address.textContent = point.address;
          content.appendChild(address);
        }

        if (point.url) {
          var link = document.createElement('a');
          link.className = 'pmap__popup-link';
          link.href = point.url;
          link.target = '_blank';
          link.rel = 'noopener';
          link.textContent = point.linkLabel || 'Voir le site';
          content.appendChild(link);
        }

        new window.mapboxgl.Marker({ color: '#c8102e' })
          .setLngLat(coords)
          .setPopup(new window.mapboxgl.Popup({ offset: 24, closeButton: false }).setDOMContent(content))
          .addTo(this.map);
      });

      this.classList.add('is-interactive');

      this.map.once('load', () => {
        this.map.resize();
        if (points.length > 1) {
          this.map.fitBounds(bounds, { padding: 70, maxZoom: 13, duration: 0 });
        } else {
          this.map.setZoom(13);
        }
      });
    }
  }

  if (!customElements.get('partners-map')) {
    customElements.define('partners-map', PartnersMap);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["map"] && !Shopify.designMode) return;
  try {
    /**
   * Carte Mapbox chargée à la demande.
   *
   * L'image statique reste visible jusqu'à ce que le visiteur demande la carte
   * interactive : la bibliothèque (≈1,5 Mo) n'est téléchargée qu'à ce moment,
   * une seule fois par page même si plusieurs cartes sont présentes.
   */
  class MapboxMap extends HTMLElement {
    connectedCallback() {
      this.button = this.querySelector('[data-map-activate]');
      if (!this.button) return;
      this.onActivate = this.activate.bind(this);
      this.button.addEventListener('click', this.onActivate);
    }

    disconnectedCallback() {
      if (this.button && this.onActivate) this.button.removeEventListener('click', this.onActivate);
      if (this.map) this.map.remove();
    }

    static loadLibrary(version) {
      if (MapboxMap.libraryPromise) return MapboxMap.libraryPromise;

      MapboxMap.libraryPromise = new Promise(function (resolve, reject) {
        var base = 'https://api.mapbox.com/mapbox-gl-js/' + version + '/mapbox-gl';

        var css = document.createElement('link');
        css.rel = 'stylesheet';
        css.href = base + '.css';
        document.head.appendChild(css);

        var script = document.createElement('script');
        script.src = base + '.js';
        script.onload = resolve;
        script.onerror = reject;
        document.head.appendChild(script);
      });

      return MapboxMap.libraryPromise;
    }

    async activate() {
      if (this.map) return;
      this.button.disabled = true;

      try {
        await MapboxMap.loadLibrary(this.dataset.glVersion);
      } catch (error) {
        // Échec de chargement : l'image statique reste en place, le lien
        // « Itinéraire » continue de fonctionner.
        this.button.disabled = false;
        return;
      }

      var center = [Number(this.dataset.lon), Number(this.dataset.lat)];
      window.mapboxgl.accessToken = this.dataset.token;

      this.map = new window.mapboxgl.Map({
        container: this.querySelector('[data-map-canvas]'),
        style: this.dataset.style,
        center: center,
        zoom: Number(this.dataset.zoom),
        // Le zoom à la molette capturerait le défilement de la page.
        cooperativeGestures: true,
        attributionControl: true,
      });

      this.map.addControl(new window.mapboxgl.NavigationControl({ showCompass: false }), 'top-right');
      new window.mapboxgl.Marker({ color: '#c8102e' }).setLngLat(center).addTo(this.map);

      this.classList.add('is-interactive');
      this.map.once('load', () => this.map.resize());
    }
  }

  if (!customElements.get('mapbox-map')) {
    customElements.define('mapbox-map', MapboxMap);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-card"] && !Shopify.designMode) return;
  try {
    /**
   * Ajout rapide depuis une carte produit.
   *
   * Un seul écouteur délégué au document : les grilles peuvent être remplacées
   * (filtres, pagination, éditeur de thème) sans réattacher quoi que ce soit.
   * Sans JavaScript, le formulaire part en POST classique vers /cart/add.
   */
  (function () {
    if (window.__crocQuickAdd) return;
    window.__crocQuickAdd = true;

    document.addEventListener('submit', function (event) {
      var form = event.target.closest('.product-card__form');
      if (!form) return;
      event.preventDefault();

      var button = form.querySelector('[data-quick-add]');
      var label = form.querySelector('[data-quick-label]');
      var input = form.querySelector('[name="id"]');
      if (!button || button.disabled || !input) return;

      var initial = label ? label.textContent : '';
      button.disabled = true;

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: Number(input.value), quantity: 1 }),
      })
        .then(function (response) {
          if (!response.ok) throw new Error('add failed');
          return fetch('/cart.js', { headers: { Accept: 'application/json' } });
        })
        .then(function (response) {
          return response.json();
        })
        .then(function (cart) {
          document.querySelectorAll('[data-cart-count]').forEach(function (node) {
            node.textContent = cart.item_count;
            node.classList.toggle('is-empty', cart.item_count === 0);
          });
          document.dispatchEvent(new CustomEvent('cart:updated', { detail: cart }));

          button.classList.add('is-done');
          if (label && button.dataset.doneLabel) label.textContent = button.dataset.doneLabel;
          setTimeout(function () {
            button.classList.remove('is-done');
            if (label) label.textContent = initial;
            button.disabled = false;
          }, 1800);
        })
        .catch(function () {
          // Échec réseau : on rend la main au parcours normal.
          button.disabled = false;
          form.submit();
        });
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["scroll-reveal"] && !Shopify.designMode) return;
  try {
    (function () {
    var SMOOTHING = 0.1; // part du chemin parcourue à chaque image
    var EPSILON = 0.0015; // en dessous, le mouvement est considéré terminé

    var pending = [];
    var frames = [];
    var running = false;
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    function reveal(el) {
      el.classList.add('is-revealed');
    }

    function revealAll() {
      document.querySelectorAll('[data-reveal]:not(.is-revealed)').forEach(reveal);
      pending = [];
    }

    if (reduce) {
      revealAll();
      return;
    }

    function collect() {
      pending = Array.prototype.slice.call(document.querySelectorAll('[data-reveal]:not(.is-revealed)'));
      frames = Array.prototype.slice
        .call(document.querySelectorAll('[data-parallax]'))
        .map(function (el) {
          return { el: el, current: 0, target: 0 };
        });
    }

    function tick() {
      var viewport = window.innerHeight;
      var middle = viewport / 2;
      var moving = false;

      // --- Lectures : on mesure tout avant d'écrire quoi que ce soit ---
      var appearing = [];
      var remaining = [];

      for (var i = 0; i < pending.length; i++) {
        var el = pending[i];
        var rect = el.getBoundingClientRect();
        // Visible dès que le haut de l'élément entre dans la fenêtre, ou s'il
        // la traverse déjà (grands blocs, rechargement à mi-page).
        if (rect.top < viewport && rect.bottom > 0) {
          appearing.push(el);
        } else {
          remaining.push(el);
        }
      }

      for (var j = 0; j < frames.length; j++) {
        var frame = frames[j];
        var box = frame.el.getBoundingClientRect();
        if (box.bottom < -300 || box.top > viewport + 300) {
          frame.offscreen = true;
          continue;
        }
        frame.offscreen = false;
        // -1 quand le cadre arrive par le bas, 0 au centre, 1 quand il sort.
        var progress = (middle - (box.top + box.height / 2)) / (middle + box.height / 2);
        frame.target = Math.max(-1, Math.min(1, progress));
      }

      // --- Écritures ---
      appearing.forEach(reveal);
      pending = remaining;

      for (var k = 0; k < frames.length; k++) {
        var f = frames[k];
        if (f.offscreen) continue;
        var delta = f.target - f.current;
        if (Math.abs(delta) < EPSILON) {
          f.current = f.target;
        } else {
          f.current += delta * SMOOTHING;
          moving = true;
        }
        f.el.style.setProperty('--p', f.current.toFixed(4));
      }

      // On continue tant qu'un cadre glisse encore, ou qu'un élément attend
      // son apparition juste sous la fenêtre.
      if (moving) {
        requestAnimationFrame(tick);
      } else {
        running = false;
      }
    }

    function schedule() {
      if (running) return;
      running = true;
      requestAnimationFrame(tick);
    }

    collect();
    schedule();

    window.addEventListener('scroll', schedule, { passive: true });
    window.addEventListener('resize', schedule, { passive: true });
    window.addEventListener('load', schedule);

    // L'éditeur de thème remplace le DOM d'une section : on reprend l'inventaire.
    document.addEventListener('shopify:section:load', function () {
      collect();
      schedule();
    });

    // Filet de sécurité : quoi qu'il arrive, plus rien n'est masqué au-delà.
    setTimeout(revealAll, 3000);
  })();
  } catch(e) { console.error(e); }
})();

})();
